export default __webpack_public_path__ + "static/media/googleLogo.bb1be251.png";